import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function LanguageSwitcher({ variant = "header" }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams();

  const currentLang = lang && ["hr", "en"].includes(lang) ? lang : i18n.language || "hr";

  const switchTo = (target) => {
    if (target === currentLang) return;
    // Build new path by replacing the first segment if it's a supported lang
    const parts = location.pathname.split("/").filter(Boolean);
    if (parts.length && ["hr", "en"].includes(parts[0])) {
      parts[0] = target;
    } else {
      parts.unshift(target);
    }
    const nextPath = "/" + parts.join("/");
    i18n.changeLanguage(target);
    if (typeof document !== "undefined") document.documentElement.lang = target;
    navigate(nextPath + location.search + location.hash);
  };

  const isHeader = variant === "header";

  return (
    <div
      role="group"
      aria-label={t("lang.switch_label")}
      data-testid="language-switcher"
      data-nav="true"
      className={"inline-flex items-center gap-1 " + (isHeader ? "" : "")}
    >
      {["hr", "en"].map((code, idx) => {
        const active = currentLang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => switchTo(code)}
            data-testid={`lang-switch-${code}`}
            aria-current={active ? "true" : "false"}
            className={
              "relative px-2 py-1 font-mono-plex text-[0.72rem] tracking-[0.14em] uppercase transition-colors duration-150 " +
              (active
                ? "text-foreground"
                : "text-muted-foreground hover:text-foreground")
            }
          >
            {t(`lang.${code}`)}
            {active && (
              <span className="absolute -bottom-1 left-2 right-2 h-px bg-primary" />
            )}
            {idx === 0 && (
              <span className="absolute -right-0.5 top-1/2 -translate-y-1/2 text-[0.6rem] text-border">
                ❘
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
